import React from "react";
import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import { tokens } from "@cobee/cobee-ui";
import useStyles from "./styles";

export default function StateLabel({
  text,
  color,
}: {
  text: string;
  color: string;
}): JSX.Element {
  const isLaptop = useMediaQuery("(max-width:1440px)");
  const COLORS = {
    green: tokens.palette.tag.success,
    yellow: tokens.palette.tag.orange,
    red: tokens.palette.tag.disabled,
    darkRed: tokens.palette.tag.error,
    grey: tokens.palette.grey[50],
  };
  const { styleLabel } = useStyles({
    stateColors: COLORS[color] || tokens.palette.tag.success,
    isLaptop,
  });
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={styleLabel}
    >
      <Typography>{text}</Typography>
    </Grid>
  );
}
